import { useMutation } from '@apollo/client';
import { DELETE_OBJECTIVE_CRITERIA_MUTATION } from '../../mutations';

export function useDeleteObjectiveCriteriaMutation() {
    return useMutation( DELETE_OBJECTIVE_CRITERIA_MUTATION );
}
